import { render, staticRenderFns } from "./SvgContent.vue?vue&type=template&id=304c4bf2&"
import script from "./SvgContent.vue?vue&type=script&lang=js&"
export * from "./SvgContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports